import './i18n'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { Suspense } from 'react'
import { hydrate, render } from 'react-dom'

import App from './App'
import { Loading } from './components/common'
import ErrorBoundary from './hoc/ErrorBoundary'

/* GTM is injected in index.html (vite-plugin-html) so the container uses the same
 * `window.dataLayer` that react-gtm-module pushes to. Avoid TagManager.initialize here
 * or the same container would load twice. */

// Initialize GA4 with all GA4 Measurement IDs (filter out Google Ads IDs)
// const ga4Ids =
//   VITE_GA4_IDS?.split(',')
//     ?.map((id: string) => id.trim())
//     ?.filter(Boolean) || []

// if (ga4Ids.length > 0) {
//   // react-ga4 supports multiple IDs by passing an array of config objects
//   // Format: [{ trackingId: 'G-XXX' }, { trackingId: 'G-YYY' }]
//   // Works for both single and multiple IDs
//   ReactGA.initialize(ga4Ids.map((id: string) => ({ trackingId: id })))
// }

dayjs.extend(customParseFormat)

const Root = () => (
  <ErrorBoundary>
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  </ErrorBoundary>
)

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  if (rootElement?.hasChildNodes()) {
    hydrate(<Root />, rootElement)
  } else {
    render(<Root />, rootElement)
  }
}
